import React from "react";
import classes from "./DetailSection.module.css";
import { cn } from "@/helper/HelperFunction";
const DetailSection = ({
  children,
  title,
  rightActions = {},
  modalDetailsClass,
  detailHeaderClass,
}) => {
  return (
    <>
      <div className={cn(classes.detailSection)}>
        <div className={cn(classes.header, detailHeaderClass)}>
          <p>{title}</p>
          {Object?.keys(rightActions)?.length > 0 && (
            <div className={classes.rightActions}>
              {Object?.keys(rightActions)?.map((e, index) => {
                return rightActions[e];
              })}
            </div>
          )}
        </div>
        <div className={cn(classes.detailContent, modalDetailsClass)}>
          {children}
        </div>
      </div>
    </>
  );
};

export default DetailSection;
